import React from "react";
import {
  Wrapper,
  StyledCurrencyInput,
  CustomSelect,
  SelectOption,
} from "./style";
import "../CustomSelect/style.css";
import { ReactComponent as DropdownIcon } from "../../../assets/icons/arrow-down.svg";
import { Select } from "antd";
import ExtendedCurrencyFlag from "../ExtendedCurrencyFlags";

const { Option } = Select;

interface Props {
  placeholder?: string;
  selectPlaceholder?: string;
  amountValue: number | string;
  selectValue?: string;
  onSelectChange?: (value: string) => void;
  onAmountChange?: (value: string | number) => void;
  options?: any[];
  width?: string;
  readOnly?: boolean;
  positionCurrencyToLeft?: boolean;
  decimalsLimit?: number;
  disableSelect?: boolean;
}

const InputAndSelect = ({
  placeholder,
  selectPlaceholder,
  amountValue,
  selectValue,
  onAmountChange,
  onSelectChange,
  options = [],
  width,
  readOnly,
  positionCurrencyToLeft = false,
  decimalsLimit = 2,
  disableSelect = false,
}: Props) => {
  return (
    <Wrapper width={width}>
      <StyledCurrencyInput
        placeholder={placeholder || "Amount"}
        value={
        amountValue
        }
        decimalsLimit={decimalsLimit}
        min={0}
        allowNegativeValue={false}
        readOnly={readOnly}
        onValueChange={(value) => {
          if (onAmountChange) {
            onAmountChange(value === undefined ? "" : value);
          }
        }}
        positionCurrencyToLeft={positionCurrencyToLeft}
      />

      <CustomSelect
        placeholder={selectPlaceholder || ""}
        dropdownMatchSelectWidth={false}
        placement="bottomLeft"
        value={selectValue}
        onChange={onSelectChange}
        disabled={disableSelect}
        open={disableSelect ? false : undefined}
        suffixIcon={disableSelect ? null : <DropdownIcon />}
        popupClassName="filter-dropdown"
        positionCurrencyToLeft={positionCurrencyToLeft}
      >
        {options.map((item) => (
          <Option key={item.value} value={item.value}>
            <SelectOption>
              <ExtendedCurrencyFlag currency={item.value}/>
              <span>{item.value}</span>
            </SelectOption>
          </Option>
        ))}
      </CustomSelect>
    </Wrapper>
  );
};

export default InputAndSelect;
